module.exports = "/_next/static/files/4dc792573901835abe946ba060caf192.png";